module.exports = __webpack_public_path__ + "img/brand.d8d4071a.png";